import { Payment } from '@modules/payment/models/payment.model';
import { PaymentOfJobType, PaymentType } from '@generated/graphql';
import { Order } from "@modules/order/models/order.model";
import { orderFactory } from "@modules/order/factories/order.factory";

export class PaymentOfJob extends Payment implements PaymentOfJobType {
  __typename: "PaymentOfJobType" = "PaymentOfJobType"
  payable: Order;

  constructor (state: PaymentOfJobType) {
    const parent: PaymentType = {
      ...state,
      __typename: 'PaymentType',
    };

    super(parent);

    this.__typename = "PaymentOfJobType"

    this.payable = state.payable ? orderFactory.create(state.payable) : null;
  }

  getModelName (): string {
    return PaymentOfJob.name;
  }
}
